export class AudioHelper {
    static Play(url) {
        let audio = new Audio();
        audio.src = url;
        audio.load();
        audio.play();
    }
}